import { graphql } from "@/lib/gql/__generated__/gql";

export const VoucherI18nUpdate_EditPage_Mutation = graphql(/* GraphQL */ `
	mutation VoucherI18nUpdate_EditPage($input: VoucherI18nInput!) {
		voucherI18nUpdate(input: $input) {
			userErrors
			voucherI18n {
				id
				lang
				hotelID
				voucherID
				name
				description
			}
		}
	}
`);
